import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNumber, IsOptional, Min } from 'class-validator';
import { StoreExposeGroup } from '../interface';
export class StoreOrderValidationDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 2, description: 'Amount of cents allowed for auto-fix', default: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    Min(0, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], StoreOrderValidationDto.prototype, "totalPosDeltaCents", void 0);
//# sourceMappingURL=StoreOrderValidationDto.js.map